import React from "react";
import {Button, Badge } from "react-bootstrap";
import { Mail, Download, ChevronLeft, ChevronRight } from "react-feather";
import "./table.css";
import Page from "./Page";

const transactions = [
  {
    Date: "Jun 22, 2023",
    Mode: "EaseBuzz Gateway",
    Payment: "₹80000",
    Status: "Received",
    id: "1",
  },
  {
    Date: "Jun 20, 2023",
    Mode: "EaseBuzz Gateway",
    Payment: "₹50000",
    Status: "Received",
    id: "2",
  },
  {
    Date: "Jun 20, 2023",
    Mode: "EaseBuzz Gateway",
    Payment: "₹20000",
    Status: "Received",
    id: "3",
  },
  {
    Date: "Jun 20, 2023",
    Mode: "EaseBuzz Gateway",
    Payment: "₹2000",
    Status: "Received",
    id: "4",
  },
];

const TransactionList = () => {

return (
  <div className="container mt-4">
  <Page />

  {/* Key Pairs Section */}
  <div className="p-3 fs-4 border rounded shadow-sm mb-3 d-none d-md-block text-white" style={{"backgroundColor":"#fd7e14"}}>
    <div className="row text-start fw-bold">
      <div className="col-md-3">Date</div>
      <div className="col-md-3">Description</div>
      <div className="col-md-2">Payment</div>
      <div className="col-md-2">Status</div>
      <div className="col-md-2">Actions</div>
    </div>
  </div>

  {/* Transactions List */}
  <div className="d-flex flex-column gap-2 text-dark fs-4">
    {transactions.map((transaction) => (
      <div key={transaction.id} className="p-3 border rounded shadow-sm">
        <div className="row g-2 align-items-center ">
          <div className="col-12 col-md-3">
            <strong className="d-md-none">Date: </strong>
            {transaction.Date}
          </div>
          <div className="col-12 col-md-3">
            <strong className="d-md-none">Description: </strong>
            {transaction.Mode}
          </div>
          <div className="col-12 col-md-2">
            <strong className="d-md-none">Payment: </strong>
            {transaction.Payment}
          </div>
          <div className="col-12 col-md-2">
            <button variant="primary" className="hover-effect rounded-3" style={{"border":"none", }}>
            <Badge bg="success p-1 fs-6 hover-effect">{transaction.Status}</Badge>
            </button>
          </div>
          <div className="col-12 col-md-2 d-flex">
            <Button variant="primary" size="sm" className="me-2 hover-effect border-0">
              <Mail size={16} />
            </Button>
            <Button variant="primary" size="sm" className="hover-effect">
              <Download size={16} />
            </Button>
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* Pagination */}
  <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap">
    <span className="text-dark fs-7">
      Showing 1 - {transactions.length} of {transactions.length} Results
    </span>
    <div className="d-flex align-items-center">
      <Button variant="link" size="sm" className="p-2 border-0 text-dark">
        <ChevronLeft size={14} />
      </Button>
      <Button size="sm" className="px-2 mx-1">
        1
      </Button>
      <Button variant="link" size="sm" className="p-2 border-0 text-dark">
        <ChevronRight size={14} />
      </Button>
    </div>
  </div>
</div>


  );
};

export default TransactionList;
